import React, { Component } from 'react';
import './index.scss';
export default (props) => {
    return (<div className="rich-editor-tools-separative"></div>);
};



// WEBPACK FOOTER //
// ./src/separative/index.js